import React, { useState, useEffect } from "react";
import PageHeading from "../../../components/PageHeading";
import {
  AddButton,
  BackButton,
  SaveButton,
} from "../../../components/btn/Buttons";
import Dropdown from "../../../components/inputs/Dropdown";
import Table from "../../../components/table/Table";
import { Input } from "../../../components/inputs/Inputs";
import { RiDeleteBin5Fill } from "react-icons/ri";
import SmallModal from "../../../components/modal/SmallModal";
import { Pagination2 } from "../../../components/pagination/pagination";
import { base_url } from "../../../utils/utils";
import moment from "moment";
import { useSelector } from "react-redux";
import { AHData } from "../../../utils/data";

const AssetsManagement = () => {
  const [flag, setFlag] = useState(false);
  const [alerts, setAlerts] = useState(false);
  const [alertsMess, setAlertsMess] = useState("");
  const [addProductData, setAddProductData] = useState([]);
  const [assetListData, setAssetListData] = useState([]);
  const [listLoading, setListLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [transactionData, setTransactionData] = useState({
    ah: "",
    description: "",
    asset_type: "",
    asset_value: "",
    dep_percent: "",
    transaction_type: "",
    transaction_date: "",
    payment_mode: "",
    bank_id: "",
  });
  const [pageNo, setPageNo] = useState(1);
  const [entries, setEntries] = useState("5"); // Keep as string to match Pagination2 component
  const [totalCount, setTotalCount] = useState(0);
  const [errors, setErrors] = useState({});
  const [banksListData, setBanksListData] = useState([]);
  const [assetTypesData, setAssetTypesData] = useState([]);
  const { user_id, today, emp_id, user_type } = useSelector(
    (state) => state.other
  );

  // Filter banks based on payment mode (account type)
  const getFilteredBanks = (paymentMode) => {
    if (!paymentMode) return banksListData;

    if (paymentMode == "1") {
      return banksListData.filter(
        (bank) => bank.ACCOUNT_TYPE?.toUpperCase() == "CASH"
      );
    } else if (paymentMode == "2") {
      return banksListData.filter(
        (bank) => bank.ACCOUNT_TYPE?.toUpperCase() == "OMC"
      );
    }

    return banksListData;
  };
  console.log("getFilteredBanks", getFilteredBanks("1"));

  // Fetch asset details and auto-fill fields
  const fetchAssetDetails = async (assetTypeId, rowIndex) => {
    try {
      if (!assetTypeId) {
        setAddProductData((prevData) => {
          const updatedData = [...prevData];
          updatedData[rowIndex] = {
            ...updatedData[rowIndex],
            asset_value: "",
            dep_percent: "",
          };
          return updatedData;
        });
        return;
      }

      setAddProductData((prevData) => {
        const updatedData = [...prevData];
        updatedData[rowIndex] = {
          ...updatedData[rowIndex],
          asset_value: "",
          dep_percent: "",
        };
        return updatedData;
      });

      const formData = new FormData();
      formData.append("action", "fetch");
      formData.append("agencyid", user_id);
      formData.append("asset_id", assetTypeId);

      const response = await fetch(
        `${base_url}financial_reports/depreciation_account.php`,
        { method: "POST", body: formData }
      );

      const result = await response.json();

      if (result.success && result.data) {
        const assetValue = parseFloat(result.data.ASSET_VALUE || 0).toFixed(2);
        const depPercent = parseFloat(
          result.data.ASSET_DEP_PERCENT || 0
        ).toFixed(2);

        setAddProductData((prevData) => {
          const updatedData = [...prevData];
          updatedData[rowIndex] = {
            ...updatedData[rowIndex],
            // asset_value: assetValue || "",
            dep_percent: depPercent || "",
          };
          return updatedData;
        });
      } else {
        console.warn("Failed to fetch asset details:", result.message);
      }
    } catch (error) {
      console.error("Error fetching asset details:", error);
    }
  };

  // Fetch banks list
  const fetchBanksList = async () => {
    try {
      const formData = new FormData();
      formData.append("action", "list");
      formData.append("agencyid", user_id);
      formData.append("page", 1);
      formData.append("limit", 1000);

      const response = await fetch(`${base_url}bank_master.php`, {
        method: "POST",
        body: formData,
      });
      const result = await response.json();
      console.log("result", result);

      if (result.success && result.data) {
        setBanksListData(result.data);
      }
    } catch (error) {
      console.error("Error fetching banks:", error);
    }
  };

  // Fetch asset types from master_data
  const fetchAssetTypes = async () => {
    try {
      const formData = new FormData();
      formData.append("action", "type_list");

      const response = await fetch(
        `${base_url}financial_reports/master_data.php`,
        { method: "POST", body: formData }
      );
      const result = await response.json();

      if (result.success && result.data) {
        setAssetTypesData(result.data);
      }
    } catch (error) {
      console.error("Error fetching asset types:", error);
    }
  };

  // Fetch assets list
  const fetchAssetsList = async (page = 1, limit = 5) => {
    try {
      setListLoading(true);

      if (!user_id) {
        setListLoading(false);
        return;
      }

      const formData = new FormData();
      formData.append("action", "list");
      formData.append("agencyid", user_id);
      formData.append("page", page);
      formData.append("limit", limit);

      const response = await fetch(
        `${base_url}financial_reports/depreciation_account.php`,
        { method: "POST", body: formData }
      );
      const result = await response.json();

      if (result.success && result.data) {
        setAssetListData(result.data);
        setTotalCount(result.totalcount || 0);
      } else {
        setAssetListData([]);
        setTotalCount(0);
      }
    } catch (error) {
      console.error("Error fetching assets list:", error);
      setAssetListData([]);
      setTotalCount(0);
    } finally {
      setListLoading(false);
    }
  };

  // Submit asset to API
  const submitAssetData = async (assetData) => {
    try {
      setLoading(true);

      if (!user_id) {
        setAlerts(true);
        setAlertsMess(
          <div style={{ color: "red", textAlign: "left" }}>
            <p>Error: Agency ID not found</p>
          </div>
        );
        return false;
      }

      const formData = new FormData();
      formData.append("action", "create");
      formData.append("agencyid", user_id);
      formData.append("ah", assetData.ah);
      formData.append("description", assetData.description);
      formData.append("asset_type", assetData.asset_type);
      formData.append("asset_value", assetData.asset_value);
      formData.append("dep_percent", assetData.dep_percent);
      formData.append("transaction_type", assetData.transaction_type);
      formData.append("transaction_date", assetData.transaction_date);
      formData.append("payment_mode", assetData.payment_mode);
      formData.append("bank_id", assetData.bank_id);
      formData.append("mop", assetData.payment_mode === "1" ? "1" : "0");
      if (emp_id) {
        formData.append("emp_code", emp_id);
      }

      const response = await fetch(
        `${base_url}financial_reports/depreciation_account.php`,
        { method: "POST", body: formData }
      );

      const result = await response.json();

      if (result.success) {
        setAlerts(true);
        setAlertsMess(
          <div style={{ color: "green", textAlign: "left" }}>
            <p>{result.message || "Asset saved successfully!"}</p>
          </div>
        );
        return true;
      } else {
        setAlerts(true);
        setAlertsMess(
          <div style={{ color: "red", textAlign: "left" }}>
            <p>{result.message || "Error saving asset data"}</p>
          </div>
        );
        return false;
      }
    } catch (error) {
      console.error("Error submitting asset data:", error);
      setAlerts(true);
      setAlertsMess(
        <div style={{ color: "red", textAlign: "left" }}>
          <p>Error: {error.message}</p>
        </div>
      );
      return false;
    } finally {
      setLoading(false);
    }
  };

  // Load data on mount
  useEffect(() => {
    if (user_id) {
      fetchAssetsList(pageNo, parseInt(entries));
      fetchBanksList();
      fetchAssetTypes();
    }
  }, [user_id]);

  // Fetch data when pageNo or entries change
  useEffect(() => {
    if (user_id) {
      fetchAssetsList(pageNo, parseInt(entries));
    }
  }, [pageNo, entries]);

  const handlePageChange = (pageNumber) => {
    setPageNo(pageNumber);
  };

  const handleEntriesChange = (newEntries) => {
    setPageNo(1); // Reset to first page when changing entries
    setEntries(newEntries);
  };

  const handleAddProduct = () => {
    const defaultProduct = {
      id: addProductData.length + 1,
      ah: "",
      description: "",
      asset_type: "",
      asset_value: "",
      dep_percent: "",
      transaction_type: "",
      transaction_date: "",
      payment_mode: "",
      bank_id: "",
    };
    if (!addProductData.length || valiDate().length === 0) {
      setAddProductData((prevData) => [...prevData, defaultProduct]);
    } else {
      const validationErrors = valiDate();
      setAlerts(true);
      setAlertsMess(
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
          }}
        >
          {validationErrors.map((item, i) => (
            <p style={{ textAlign: "left" }} key={i}>
              {item}
            </p>
          ))}
        </div>
      );
    }
  };

  const handleInputChange = (field, value, index) => {
    setAddProductData((prevData) => {
      const updatedData = [...prevData];
      updatedData[index] = {
        ...updatedData[index],
        [field]: value,
      };
      return updatedData;
    });
    setErrors((prev) => ({ ...prev, [field]: null }));
  };

  const valiDate = () => {
    const errors = [];
    let count = 1;

    for (let v of addProductData) {
      if (!v?.ah || v?.ah.trim().length === 0) {
        errors.push(`Please enter Account Head (AH) in Row ${count}`);
      }
      if (!v?.description || v?.description.trim().length === 0) {
        errors.push(`Please enter Description in Row ${count}`);
      }
      if (!v?.asset_type || v?.asset_type.trim().length === 0) {
        errors.push(`Please select Asset Type in Row ${count}`);
      }
      if (!v?.asset_value || v?.asset_value.trim().length === 0) {
        errors.push(`Please enter Asset Value in Row ${count}`);
      } else if (isNaN(Number(v?.asset_value))) {
        errors.push(`Asset Value must be a number in Row ${count}`);
      }
      if (!v?.dep_percent || v?.dep_percent.trim().length === 0) {
        errors.push(`Please enter Depreciation % in Row ${count}`);
      } else if (isNaN(Number(v?.dep_percent))) {
        errors.push(`Depreciation % must be a number in Row ${count}`);
      }
      if (!v?.transaction_type || v?.transaction_type.trim().length === 0) {
        errors.push(`Please select Transaction Type in Row ${count}`);
      }
      if (!v?.transaction_date || v?.transaction_date.trim().length === 0) {
        errors.push(`Please select Transaction Date in Row ${count}`);
      }
      if (!v?.payment_mode || v?.payment_mode.trim().length === 0) {
        errors.push(`Please select Payment Mode in Row ${count}`);
      }
      if (!v?.bank_id || v?.bank_id.trim().length === 0) {
        errors.push(`Please select Bank in Row ${count}`);
      }
      count++;
    }

    return errors;
  };

  const handleSaveProduct = async () => {
    const validationErrors = valiDate();

    if (validationErrors.length > 0) {
      setAlerts(true);
      setAlertsMess(
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
          }}
        >
          {validationErrors.map((item, i) => (
            <p style={{ textAlign: "left" }} key={i}>
              {item}
            </p>
          ))}
        </div>
      );
      return;
    }

    let successCount = 0;
    let failureCount = 0;

    for (const asset of addProductData) {
      const success = await submitAssetData(asset);
      if (success) {
        successCount++;
      } else {
        failureCount++;
      }
    }

    if (failureCount === 0 && successCount > 0) {
      setAlerts(true);
      setAlertsMess(
        <div style={{ color: "green", textAlign: "left" }}>
          <p>✓ All {successCount} asset(s) saved successfully!</p>
        </div>
      );
      setTimeout(() => {
        setAddProductData([]);
        setFlag(false);
        setPageNo(1); // Reset to first page after saving
        fetchAssetsList(1, parseInt(entries));
      }, 2000);
    } else if (successCount > 0 && failureCount > 0) {
      setAlerts(true);
      setAlertsMess(
        <div style={{ color: "orange", textAlign: "left" }}>
          <p>
            ⚠ {successCount} asset(s) saved, but {failureCount} failed
          </p>
        </div>
      );
      setTimeout(() => {
        fetchAssetsList(pageNo, parseInt(entries));
      }, 2000);
    }
  };

  const handleAddDelete = (deleteId) => {
    const filterData = addProductData.filter((item) => item.id !== deleteId);
    setAddProductData(filterData);
  };

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getFinancialYearStartDate = () => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const fyStartYear = today.getMonth() < 3 ? currentYear - 1 : currentYear;
    return `${fyStartYear}-04-01`;
  };

  return (
    <div className="container">
      <PageHeading
        title={"ASSETS MANAGEMENT"}
        right={
          <>
            <AddButton
              onClick={() => {
                setFlag(true);
                handleAddProduct();
              }}
              disabled={loading}
              style={loading ? { opacity: 0.5, cursor: "not-allowed" } : {}}
            />
            <SaveButton
              title={loading ? "SAVING..." : "SAVE"}
              onClick={handleSaveProduct}
              disabled={loading || addProductData.length === 0}
            />
            <BackButton />
          </>
        }
      />
      <div style={{ height: "20px" }}></div>

      {flag && addProductData.length > 0 && (
        <Table
          mt={5}
          headData={[
            "ACCOUNT HEAD",
            "DESCRIPTION",
            "ASSET TYPE",
            "ASSETS VALUE",
            "DEP %",
            "TRANSACTION TYPE",
            "TRANSACTION DATE",
            "PAYMENT MODE",
            "BANK",
            "ACTIONS",
          ]}
          body={
            <>
              {addProductData.map((item, index) => (
                <tr key={item.id}>
                  <td>
                    <Dropdown
                      value={item.ah}
                      onChange={(e) => {
                        const assetTypeId = e.target.value;
                        handleInputChange("ah", assetTypeId, index);
                      }}
                      options={
                        <>
                          <option value={""}>SELECT</option>
                          {AHData.map((item) => (
                            <option value={item.AH} key={item.id}>
                              {item.title}
                            </option>
                          ))}
                        </>
                      }
                    />
                    {/* <Input
                      placeholder={"Account Head"}
                      value={item.ah}
                      onChange={(e) =>
                        handleInputChange("ah", e.target.value, index)
                      }
                    /> */}
                  </td>
                  <td>
                    <Input
                      placeholder={"Description"}
                      value={item.description}
                      onChange={(e) =>
                        handleInputChange("description", e.target.value, index)
                      }
                    />
                  </td>
                  <td>
                    <Dropdown
                      value={item.asset_type}
                      onChange={(e) => {
                        const assetTypeId = e.target.value;
                        handleInputChange("asset_type", assetTypeId, index);
                        if (assetTypeId) {
                          fetchAssetDetails(assetTypeId, index);
                        }
                      }}
                      options={
                        <>
                          <option value="">SELECT ASSET TYPE</option>
                          {assetTypesData.map((assetType) => (
                            <option key={assetType.ID} value={assetType.ID}>
                              {assetType.ITEM}
                            </option>
                          ))}
                        </>
                      }
                    />
                  </td>
                  <td>
                    <Input
                      placeholder={"Value"}
                      type="number"
                      value={item.asset_value}
                      onChange={(e) =>
                        handleInputChange("asset_value", e.target.value, index)
                      }
                    />
                  </td>
                  <td>
                    <Input
                      placeholder={"Depreciation %"}
                      type="number"
                      value={item.dep_percent}
                      onChange={(e) =>
                        handleInputChange("dep_percent", e.target.value, index)
                      }
                      readOnly
                      style={{
                        backgroundColor: "#f5f5f5",
                        cursor: "not-allowed",
                      }}
                    />
                  </td>
                  <td>
                    <Dropdown
                      value={item.transaction_type}
                      onChange={(e) =>
                        handleInputChange(
                          "transaction_type",
                          e.target.value,
                          index
                        )
                      }
                      options={
                        <>
                          <option value="">SELECT</option>
                          <option value="1">PURCHASE</option>
                          <option value="2">SALES</option>
                          <option value="3">TRANSFER</option>
                          <option value="4">LOSS</option>
                        </>
                      }
                    />
                  </td>
                  <td>
                    <Input
                      type="date"
                      value={item.transaction_date}
                      onChange={(e) =>
                        handleInputChange(
                          "transaction_date",
                          e.target.value,
                          index
                        )
                      }
                      min={getFinancialYearStartDate()}
                      max={getTodayDate()}
                    />
                  </td>
                  <td>
                    <Dropdown
                      value={item.payment_mode}
                      onChange={(e) => {
                        handleInputChange(
                          "payment_mode",
                          e.target.value,
                          index
                        );
                        // Clear bank selection when payment mode changes
                        handleInputChange("bank_id", "", index);
                      }}
                      options={
                        <>
                          <option value="">SELECT</option>
                          <option value="1">Cash</option>
                          <option value="2">Online</option>
                        </>
                      }
                    />
                  </td>
                  <td>
                    <Dropdown
                      value={item.bank_id}
                      onChange={(e) =>
                        handleInputChange("bank_id", e.target.value, index)
                      }
                      disabled={!item.payment_mode}
                      options={
                        <>
                          <option value="">SELECT BANK</option>
                          {getFilteredBanks(item.payment_mode).map((bank) => {
                            const bankCode = bank.BANK_CODE || "";
                            const nickName =
                              bank.NICK_NAME || bank.BANK_NAME || "";
                            const accountNo = bank.BANK_ACC_NO || "";
                            const last4Digits = accountNo.slice(-4);
                            const displayLabel = `${bankCode}-${nickName}-${last4Digits}`;
                            return (
                              <option key={bank.ID} value={bank.ID}>
                                {displayLabel}
                              </option>
                            );
                          })}
                        </>
                      }
                    />
                  </td>
                  <td>
                    <RiDeleteBin5Fill
                      style={{ cursor: "pointer", color: "red" }}
                      size={20}
                      onClick={() => handleAddDelete(item.id)}
                    />
                  </td>
                </tr>
              ))}
            </>
          }
        />
      )}

      <div style={{ height: "10px" }}></div>

      <Pagination2
        top={true}
        bottom={false}
        totalCount={totalCount}
        pageNo={pageNo}
        setPageNo={setPageNo}
        entries={entries}
        setEntries={setEntries}
        search={false}
        count={5}
      />

      <Table
        mt={5}
        headData={[
          // "SR NO",
          "Account Head",
          "DESCRIPTION",
          "ASSET Type",
          "ASSET VALUE",
          "DEP %",
          "TRANSACTION TYPE",
          "TRANSACTION DATE",
          "PAYMENT MODE",
          "BANK CODE",
        ]}
        body={
          <>
            {listLoading ? (
              <tr>
                <td
                  colSpan="9"
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  Loading...
                </td>
              </tr>
            ) : assetListData && assetListData.length > 0 ? (
              assetListData.map((item, index) => (
                <tr key={index}>
                  {/* <td>{(pageNo - 1) * parseInt(entries) + index + 1}</td> */}
                  <td>{item.ASSET_AH}</td>
                  <td>{item.ASSET_DESC}</td>
                  <td>{item.ASSET_TYPE}</td>
                  <td>
                    ₹
                    {parseFloat(item.ASSET_VALUE).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </td>
                  <td>{parseFloat(item.ASSET_DEP_PERCENT).toFixed(2)}%</td>
                  <td>{item.TRANSACTION_TYPE_TEXT || "N/A"}</td>
                  <td>
                    {item.TRANSACTION_DATE ? item.TRANSACTION_DATE : "N/A"}
                  </td>
                  <td>{item.PAYMENT_MODE == "1" ? "Cash" : "Online"}</td>
                  <td>{item.BANK_CODE || "N/A"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="9"
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  No assets found
                </td>
              </tr>
            )}
          </>
        }
      />

      <Pagination2
        top={false}
        bottom={true}
        totalCount={totalCount}
        pageNo={pageNo}
        setPageNo={setPageNo}
        entries={entries}
        setEntries={setEntries}
        search={false}
        count={5}
      />

      {alerts && (
        <SmallModal
          isOpen={alerts}
          setIsOpen={setAlerts}
          title={"Alert"}
          mess={alertsMess}
          okbtn={() => setAlerts(false)}
        />
      )}
    </div>
  );
};

export default AssetsManagement;
// import React, { useState, useEffect } from "react";
// import PageHeading from "../../../components/PageHeading";
// import {
//   AddButton,
//   BackButton,
//   SaveButton,
// } from "../../../components/btn/Buttons";
// import Dropdown from "../../../components/inputs/Dropdown";
// import Table from "../../../components/table/Table";
// import { Input } from "../../../components/inputs/Inputs";
// import { RiDeleteBin5Fill } from "react-icons/ri";
// import SmallModal from "../../../components/modal/SmallModal";
// import { Pagination2 } from "../../../components/pagination/pagination";
// import { base_url } from "../../../utils/utils";
// import moment from "moment";
// import { useSelector } from "react-redux";

// const AssetsManagement = () => {
//   const [flag, setFlag] = useState(false);
//   const [alerts, setAlerts] = useState(false);
//   const [alertsMess, setAlertsMess] = useState("");
//   const [addProductData, setAddProductData] = useState([]);
//   const [assetListData, setAssetListData] = useState([]);
//   const [listLoading, setListLoading] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [transactionData, setTransactionData] = useState({
//     ah: "",
//     description: "",
//     asset_type: "",
//     asset_value: "",
//     dep_percent: "",
//     transaction_type: "",
//     transaction_date: "",
//     payment_mode: "",
//     bank_id: "",
//   });
//   const [pageNo, setPageNo] = useState(1);
//   const [entries, setEntries] = useState(5);
//   const [totalCount, setTotalCount] = useState(0);
//   const [errors, setErrors] = useState({});
//   const [banksListData, setBanksListData] = useState([]);
//   const [assetTypesData, setAssetTypesData] = useState([]);
//   const { user_id, today, emp_id, user_type } = useSelector(
//     (state) => state.other
//   );

//   // Filter banks based on payment mode (account type)
//   const getFilteredBanks = (paymentMode) => {
//     if (!paymentMode) return banksListData;

//     if (paymentMode === "1") {
//       // Cash mode - show only CASH account type
//       return banksListData.filter(
//         (bank) => bank.ACCOUNT_TYPE?.toUpperCase() === "CASH"
//       );
//     } else if (paymentMode === "2") {
//       // Online mode - show only OMC (Online) account type
//       return banksListData.filter(
//         (bank) => bank.ACCOUNT_TYPE?.toUpperCase() === "OMC"
//       );
//     }

//     return banksListData;
//   };

//   // Fetch asset details and auto-fill fields
//   const fetchAssetDetails = async (assetTypeId, rowIndex) => {
//     try {
//       if (!assetTypeId) {
//         // Clear fields if asset type is empty
//         setAddProductData((prevData) => {
//           const updatedData = [...prevData];
//           updatedData[rowIndex] = {
//             ...updatedData[rowIndex],
//             asset_value: "",
//             dep_percent: "",
//           };
//           return updatedData;
//         });
//         return;
//       }

//       // Clear fields first while fetching
//       setAddProductData((prevData) => {
//         const updatedData = [...prevData];
//         updatedData[rowIndex] = {
//           ...updatedData[rowIndex],
//           asset_value: "",
//           dep_percent: "",
//         };
//         return updatedData;
//       });

//       const formData = new FormData();
//       formData.append("action", "fetch");
//       formData.append("agencyid", user_id);
//       formData.append("asset_id", assetTypeId);

//       const response = await fetch(
//         `${base_url}financial_reports/depreciation_account.php`,
//         { method: "POST", body: formData }
//       );

//       const result = await response.json();

//       if (result.success && result.data) {
//         // Auto-fill the asset_value and dep_percent fields with fresh data (formatted to 2 decimals)
//         const assetValue = parseFloat(result.data.ASSET_VALUE || 0).toFixed(2);
//         const depPercent = parseFloat(
//           result.data.ASSET_DEP_PERCENT || 0
//         ).toFixed(2);

//         setAddProductData((prevData) => {
//           const updatedData = [...prevData];
//           updatedData[rowIndex] = {
//             ...updatedData[rowIndex],
//             asset_value: assetValue || "",
//             dep_percent: depPercent || "",
//           };
//           return updatedData;
//         });
//       } else {
//         // If fetch fails, keep fields empty
//         console.warn("Failed to fetch asset details:", result.message);
//       }
//     } catch (error) {
//       console.error("Error fetching asset details:", error);
//       // Keep fields empty on error
//     }
//   };

//   // Fetch banks list
//   const fetchBanksList = async () => {
//     try {
//       const formData = new FormData();
//       formData.append("action", "list");
//       formData.append("agencyid", user_id);
//       formData.append("page", 1);
//       formData.append("limit", 1000);

//       const response = await fetch(`${base_url}bank_master.php`, {
//         method: "POST",
//         body: formData,
//       });
//       const result = await response.json();

//       if (result.success && result.data) {
//         setBanksListData(result.data);
//       }
//     } catch (error) {
//       console.error("Error fetching banks:", error);
//     }
//   };

//   // Fetch asset types from master_data
//   const fetchAssetTypes = async () => {
//     try {
//       const formData = new FormData();
//       formData.append("action", "type_list");

//       const response = await fetch(
//         `${base_url}financial_reports/master_data.php`,
//         { method: "POST", body: formData }
//       );
//       const result = await response.json();

//       if (result.success && result.data) {
//         setAssetTypesData(result.data);
//       }
//     } catch (error) {
//       console.error("Error fetching asset types:", error);
//     }
//   };

//   // Fetch assets list
//   const fetchAssetsList = async (page = 1, limit = 5) => {
//     try {
//       setListLoading(true);

//       if (!user_id) {
//         setListLoading(false);
//         return;
//       }

//       const formData = new FormData();
//       formData.append("action", "list");
//       formData.append("agencyid", user_id);
//       formData.append("page", page);
//       formData.append("limit", limit);

//       const response = await fetch(
//         `${base_url}financial_reports/depreciation_account.php`,
//         { method: "POST", body: formData }
//       );
//       const result = await response.json();

//       if (result.success && result.data) {
//         setAssetListData(result.data);
//         setTotalCount(result.totalcount || 0);
//         setPageNo(page);
//       } else {
//         setAssetListData([]);
//       }
//     } catch (error) {
//       console.error("Error fetching assets list:", error);
//     } finally {
//       setListLoading(false);
//     }
//   };

//   // Submit asset to API
//   const submitAssetData = async (assetData) => {
//     try {
//       setLoading(true);

//       if (!user_id) {
//         setAlerts(true);
//         setAlertsMess(
//           <div style={{ color: "red", textAlign: "left" }}>
//             <p>Error: Agency ID not found</p>
//           </div>
//         );
//         return false;
//       }

//       const formData = new FormData();
//       formData.append("action", "create");
//       formData.append("agencyid", user_id);
//       formData.append("ah", assetData.ah);
//       formData.append("description", assetData.description);
//       formData.append("asset_type", assetData.asset_type);
//       formData.append("asset_value", assetData.asset_value);
//       formData.append("dep_percent", assetData.dep_percent);
//       formData.append("transaction_type", assetData.transaction_type);
//       formData.append("transaction_date", assetData.transaction_date);
//       formData.append("payment_mode", assetData.payment_mode);
//       formData.append("bank_id", assetData.bank_id);
//       formData.append("mop", assetData.payment_mode === "1" ? "1" : "0");
//       if (emp_id) {
//         formData.append("emp_code", emp_id);
//       }

//       const response = await fetch(
//         `${base_url}financial_reports/depreciation_account.php`,
//         { method: "POST", body: formData }
//       );

//       const result = await response.json();

//       if (result.success) {
//         setAlerts(true);
//         setAlertsMess(
//           <div style={{ color: "green", textAlign: "left" }}>
//             <p>{result.message || "Asset saved successfully!"}</p>
//           </div>
//         );
//         return true;
//       } else {
//         setAlerts(true);
//         setAlertsMess(
//           <div style={{ color: "red", textAlign: "left" }}>
//             <p>{result.message || "Error saving asset data"}</p>
//           </div>
//         );
//         return false;
//       }
//     } catch (error) {
//       console.error("Error submitting asset data:", error);
//       setAlerts(true);
//       setAlertsMess(
//         <div style={{ color: "red", textAlign: "left" }}>
//           <p>Error: {error.message}</p>
//         </div>
//       );
//       return false;
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Load data on mount
//   useEffect(() => {
//     fetchAssetsList();
//     fetchBanksList();
//     fetchAssetTypes();
//   }, []);

//   const handlePageChange = (pageNumber) => {
//     setPageNo(pageNumber);
//     fetchAssetsList(pageNumber, parseInt(entries));
//   };

//   const handleEntriesChange = (newEntries) => {
//     setPageNo(1);
//     setEntries(newEntries);
//     fetchAssetsList(1, parseInt(newEntries));
//   };

//   const handleAddProduct = () => {
//     const defaultProduct = {
//       id: addProductData.length + 1,
//       ah: "",
//       description: "",
//       asset_type: "",
//       asset_value: "",
//       dep_percent: "",
//       transaction_type: "",
//       transaction_date: "",
//       payment_mode: "",
//       bank_id: "",
//     };
//     if (!addProductData.length || valiDate().length === 0) {
//       setAddProductData((prevData) => [...prevData, defaultProduct]);
//     } else {
//       const validationErrors = valiDate();
//       setAlerts(true);
//       setAlertsMess(
//         <div
//           style={{
//             width: "100%",
//             display: "flex",
//             flexDirection: "column",
//             justifyContent: "flex-start",
//           }}
//         >
//           {validationErrors.map((item, i) => (
//             <p style={{ textAlign: "left" }} key={i}>
//               {item}
//             </p>
//           ))}
//         </div>
//       );
//     }
//   };

//   const handleInputChange = (field, value, index) => {
//     setAddProductData((prevData) => {
//       const updatedData = [...prevData];
//       updatedData[index] = {
//         ...updatedData[index],
//         [field]: value,
//       };
//       return updatedData;
//     });
//     // Remove errors as user types
//     setErrors((prev) => ({ ...prev, [field]: null }));
//   };

//   const valiDate = () => {
//     const errors = [];
//     let count = 1;

//     for (let v of addProductData) {
//       if (!v?.ah || v?.ah.trim().length === 0) {
//         errors.push(`Please enter Account Head (AH) in Row ${count}`);
//       }
//       if (!v?.description || v?.description.trim().length === 0) {
//         errors.push(`Please enter Description in Row ${count}`);
//       }
//       if (!v?.asset_type || v?.asset_type.trim().length === 0) {
//         errors.push(`Please select Asset Type in Row ${count}`);
//       }
//       if (!v?.asset_value || v?.asset_value.trim().length === 0) {
//         errors.push(`Please enter Asset Value in Row ${count}`);
//       } else if (isNaN(Number(v?.asset_value))) {
//         errors.push(`Asset Value must be a number in Row ${count}`);
//       }
//       if (!v?.dep_percent || v?.dep_percent.trim().length === 0) {
//         errors.push(`Please enter Depreciation % in Row ${count}`);
//       } else if (isNaN(Number(v?.dep_percent))) {
//         errors.push(`Depreciation % must be a number in Row ${count}`);
//       }
//       if (!v?.transaction_type || v?.transaction_type.trim().length === 0) {
//         errors.push(`Please select Transaction Type in Row ${count}`);
//       }
//       if (!v?.transaction_date || v?.transaction_date.trim().length === 0) {
//         errors.push(`Please select Transaction Date in Row ${count}`);
//       }
//       if (!v?.payment_mode || v?.payment_mode.trim().length === 0) {
//         errors.push(`Please select Payment Mode in Row ${count}`);
//       }
//       count++;
//     }

//     return errors;
//   };

//   const handleSaveProduct = async () => {
//     const validationErrors = valiDate();

//     if (validationErrors.length > 0) {
//       setAlerts(true);
//       setAlertsMess(
//         <div
//           style={{
//             width: "100%",
//             display: "flex",
//             flexDirection: "column",
//             justifyContent: "flex-start",
//           }}
//         >
//           {validationErrors.map((item, i) => (
//             <p style={{ textAlign: "left" }} key={i}>
//               {item}
//             </p>
//           ))}
//         </div>
//       );
//       return;
//     }

//     let successCount = 0;
//     let failureCount = 0;

//     for (const asset of addProductData) {
//       const success = await submitAssetData(asset);
//       if (success) {
//         successCount++;
//       } else {
//         failureCount++;
//       }
//     }

//     if (failureCount === 0 && successCount > 0) {
//       setAlerts(true);
//       setAlertsMess(
//         <div style={{ color: "green", textAlign: "left" }}>
//           <p>✓ All {successCount} asset(s) saved successfully!</p>
//         </div>
//       );
//       setTimeout(() => {
//         setAddProductData([]);
//         setFlag(false);
//         fetchAssetsList(1, parseInt(entries));
//       }, 2000);
//     } else if (successCount > 0 && failureCount > 0) {
//       setAlerts(true);
//       setAlertsMess(
//         <div style={{ color: "orange", textAlign: "left" }}>
//           <p>
//             ⚠ {successCount} asset(s) saved, but {failureCount} failed
//           </p>
//         </div>
//       );
//     }
//   };

//   const handleAddDelete = (deleteId) => {
//     const filterData = addProductData.filter((item) => item.id !== deleteId);
//     setAddProductData(filterData);
//   };

//   // Get today's date in YYYY-MM-DD format for date input max attribute
//   const getTodayDate = () => {
//     const today = new Date();
//     const year = today.getFullYear();
//     const month = String(today.getMonth() + 1).padStart(2, "0");
//     const day = String(today.getDate()).padStart(2, "0");
//     return `${year}-${month}-${day}`;
//   };

//   // Get Financial Year Start Date (April 1st)
//   const getFinancialYearStartDate = () => {
//     const today = new Date();
//     const currentYear = today.getFullYear();

//     // If current date is before April 1, FY starts in previous year
//     // If current date is April 1 or after, FY starts in current year
//     const fyStartYear = today.getMonth() < 3 ? currentYear - 1 : currentYear;

//     return `${fyStartYear}-04-01`;
//   };

//   return (
//     <div className="container">
//       <PageHeading
//         title={"ASSETS MANAGEMENT"}
//         right={
//           <>
//             <AddButton
//               onClick={() => {
//                 setFlag(true);
//                 handleAddProduct();
//               }}
//               disabled={loading}
//               style={loading ? { opacity: 0.5, cursor: "not-allowed" } : {}}
//             />
//             <SaveButton
//               title={loading ? "SAVING..." : "SAVE"}
//               onClick={handleSaveProduct}
//               disabled={loading}
//             />
//             <BackButton />
//           </>
//         }
//       />
//       <div style={{ height: "20px" }}></div>

//       {flag && addProductData.length > 0 && (
//         <Table
//           mt={5}
//           headData={[
//             "ACCOUNT HEAD",
//             "DESCRIPTION",
//             "ASSET TYPE",
//             "assets VALUE",
//             "DEP %",
//             "TRANSACTION TYPE",
//             "TRANSACTION DATE",
//             "PAYMENT MODE",
//             "BANK",
//             "ACTIONS",
//           ]}
//           body={
//             <>
//               {addProductData.map((item, index) => (
//                 <tr key={item.id}>
//                   <td>
//                     <Input
//                       placeholder={"Account Head"}
//                       value={item.ah}
//                       onChange={(e) =>
//                         handleInputChange("ah", e.target.value, index)
//                       }
//                     />
//                   </td>
//                   <td>
//                     <Input
//                       placeholder={"Description"}
//                       value={item.description}
//                       onChange={(e) =>
//                         handleInputChange("description", e.target.value, index)
//                       }
//                     />
//                   </td>
//                   <td>
//                     <Dropdown
//                       value={item.asset_type}
//                       onChange={(e) => {
//                         const assetTypeId = e.target.value;
//                         handleInputChange("asset_type", assetTypeId, index);
//                         // Fetch asset details when asset type is selected
//                         if (assetTypeId) {
//                           fetchAssetDetails(assetTypeId, index);
//                         }
//                       }}
//                       options={
//                         <>
//                           <option value="">SELECT ASSET TYPE</option>
//                           {assetTypesData.map((assetType) => (
//                             <option key={assetType.ID} value={assetType.ID}>
//                               {assetType.ITEM}
//                             </option>
//                           ))}
//                         </>
//                       }
//                     />
//                   </td>
//                   <td>
//                     <Input
//                       placeholder={"Value"}
//                       type="number"
//                       value={item.asset_value}
//                       onChange={(e) =>
//                         handleInputChange("asset_value", e.target.value, index)
//                       }
//                     />
//                   </td>
//                   <td>
//                     <Input
//                       placeholder={"Depreciation %"}
//                       type="number"
//                       value={item.dep_percent}
//                       onChange={(e) =>
//                         handleInputChange("dep_percent", e.target.value, index)
//                       }
//                       readOnly
//                       style={{
//                         backgroundColor: "#f5f5f5",
//                         cursor: "not-allowed",
//                       }}
//                     />
//                   </td>
//                   <td>
//                     <Dropdown
//                       value={item.transaction_type}
//                       onChange={(e) =>
//                         handleInputChange(
//                           "transaction_type",
//                           e.target.value,
//                           index
//                         )
//                       }
//                       options={
//                         <>
//                           <option value="">SELECT</option>
//                           <option value="1">PURCHASE</option>
//                           <option value="2">SALES</option>
//                           <option value="3">TRANSFER</option>
//                           <option value="3">LOSS</option>
//                         </>
//                       }
//                     />
//                   </td>
//                   <td>
//                     <Input
//                       type="date"
//                       value={item.transaction_date}
//                       onChange={(e) =>
//                         handleInputChange(
//                           "transaction_date",
//                           e.target.value,
//                           index
//                         )
//                       }
//                       min={getFinancialYearStartDate()}
//                       max={getTodayDate()}
//                     />
//                   </td>
//                   <td>
//                     <Dropdown
//                       value={item.payment_mode}
//                       onChange={(e) =>
//                         handleInputChange("payment_mode", e.target.value, index)
//                       }
//                       options={
//                         <>
//                           <option value="">SELECT</option>
//                           <option value="1">Cash</option>
//                           <option value="2">Online</option>
//                         </>
//                       }
//                     />
//                   </td>
//                   <td>
//                     <Dropdown
//                       value={item.bank_id}
//                       onChange={(e) =>
//                         handleInputChange("bank_id", e.target.value, index)
//                       }
//                       disabled={!item.payment_mode}
//                       options={
//                         <>
//                           <option value="">
//                             {item.payment_mode
//                               ? "SELECT BANK"
//                               : "SELECT PAYMENT MODE FIRST"}
//                           </option>
//                           {getFilteredBanks(item.payment_mode).map((bank) => {
//                             const bankCode = bank.BANK_CODE || "";
//                             const nickName =
//                               bank.NICK_NAME || bank.BANK_NAME || "";
//                             const accountNo = bank.BANK_ACC_NO || "";
//                             const last4Digits = accountNo.slice(-4);
//                             const displayLabel = `${bankCode}-${nickName}-${last4Digits}`;
//                             return (
//                               <option key={bank.ID} value={bank.ID}>
//                                 {displayLabel}
//                               </option>
//                             );
//                           })}
//                         </>
//                       }
//                     />
//                   </td>
//                   <td>
//                     <RiDeleteBin5Fill
//                       style={{ cursor: "pointer" }}
//                       onClick={() => handleAddDelete(item.id)}
//                     />
//                   </td>
//                 </tr>
//               ))}
//             </>
//           }
//         />
//       )}

//       <div style={{ height: "10px" }}></div>

//       <Pagination2
//         top={true}
//         bottom={false}
//         totalCount={totalCount}
//         pageNo={pageNo}
//         setPageNo={handlePageChange}
//         entries={entries}
//         setEntries={handleEntriesChange}
//         search={false}
//         count={5}
//       />

//       <Table
//         mt={5}
//         headData={[
//           "SR NO",
//           "ASSET NAME",
//           "ASSET VALUE",
//           "DEP %",
//           "DESCRIPTION",
//           "TRANSACTION TYPE",
//           "TRANSACTION DATE",
//           "PAYMENT MODE",
//           "BANK CODE",
//         ]}
//         body={
//           <>
//             {assetListData && assetListData.length > 0 ? (
//               assetListData.map((item, index) => (
//                 <tr key={index}>
//                   <td>{item.SR_NO}</td>
//                   <td>{item.ASSET_NAME || item.ASSET_TYPE}</td>
//                   <td>
//                     ₹
//                     {parseFloat(item.ASSET_VALUE).toLocaleString(undefined, {
//                       maximumFractionDigits: 2,
//                     })}
//                   </td>
//                   <td>{parseFloat(item.ASSET_DEP_PERCENT).toFixed(2)}%</td>
//                   <td>{item.ASSET_DESC}</td>
//                   <td>
//                     {item.TRANSACTION_TYPE_TEXT ||
//                       (item.TRANSACTION_TYPE === "1"
//                         ? "Purchase"
//                         : item.TRANSACTION_TYPE === "2"
//                         ? "Addition"
//                         : "Exit")}
//                   </td>
//                   <td>{item.TRANSACTION_DATE}</td>
//                   <td>{item.PAYMENT_MODE == "1" ? "Cash" : "Online"}</td>
//                   <td>{item.BANK_CODE}</td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td
//                   colSpan="8"
//                   style={{ textAlign: "center", padding: "20px" }}
//                 >
//                   {listLoading ? "Loading..." : "No assets found"}
//                 </td>
//               </tr>
//             )}
//           </>
//         }
//       />

//       <Pagination2
//         top={false}
//         bottom={true}
//         totalCount={totalCount}
//         pageNo={pageNo}
//         setPageNo={handlePageChange}
//         entries={entries}
//         setEntries={handleEntriesChange}
//         search={false}
//         count={5}
//       />

//       {alerts && (
//         <SmallModal
//           isOpen={alerts}
//           setIsOpen={setAlerts}
//           title={"alert"}
//           mess={alertsMess}
//           okbtn={setAlertsMess}
//         />
//       )}
//     </div>
//   );
// };

// export default AssetsManagement;

// // import React, { useState } from "react";
// // import PageHeading from "../../../components/PageHeading";
// // import {
// //   AddButton,
// //   BackButton,
// //   SaveButton,
// // } from "../../../components/btn/Buttons";
// // import Dropdown from "../../../components/inputs/Dropdown";
// // import Table from "../../../components/table/Table";
// // import { Input } from "../../../components/inputs/Inputs";
// // import { RiDeleteBin5Fill } from "react-icons/ri";
// // import SmallModal from "../../../components/modal/SmallModal";

// // const AssetsManagement = () => {
// //   const [flag, setFlag] = useState(false);
// //   const [alerts, setAlerts] = useState(false);
// //   const [alertsMess, setAlertsMess] = useState("");
// //   const [addProductData, setAddProductData] = useState([]);
// //   const [transactionData, setTransactionData] = useState({
// //     transactionDate: '',
// //     transactionType: '',
// //     itemDesc: '',
// //     accountHead: '',
// //     value: '',
// //     modeOfPayment: '',
// //     bank: '',
// //     staff: ''
// //   });

// //   const [errors, setErrors] = useState({});

// //   const handleAddProduct = () => {
// //     const defaultProduct = {
// //       id: addProductData.length + 1,
// //       NAME: "",
// //       PAN: "",
// //       PERC_OF_SHARE: "",
// //       OPENING_BALANCE: "",
// //       STATUS: "",
// //       ACTIONS: "",
// //     };
// //     if (!addProductData.length || valiDate().length === 0) {
// //       setAddProductData((prevData) => [...prevData, defaultProduct]);
// //     } else {
// //       // setAddProductData((prevData) => [...prevData, defaultProduct]);
// //       const validationErrors = valiDate();
// //       setAlerts(true);
// //       setAlertsMess(
// //         <div
// //           style={{
// //             width: "100%",
// //             display: "flex",
// //             flexDirection: "column",
// //             justifyContent: "flex-start",
// //           }}
// //         >
// //           {validationErrors.map((item, i) => (
// //             <p style={{ textAlign: "left" }} key={i}>
// //               {item}
// //             </p>
// //           ))}
// //         </div>
// //       );
// //     }
// //   };

// //   const handleInputChange = (field, value) => {
// //     setTransactionData(prev => ({
// //       ...prev,
// //       [field]: value
// //     }));
// //     // Remove errors as user types
// //     setErrors(prev => ({ ...prev, [field]: null }));
// //   };

// //   const valiDate = () => {
// //     const errors = [];

// //     // Validate transactionDate
// //     if (!transactionData.transactionDate.trim()) {
// //       errors.push("Transaction date is required.");
// //     }

// //     // Validate transactionType
// //     if (!transactionData.transactionType.trim()) {
// //       errors.push("Transaction type is required.");
// //     }

// //     // Validate itemDesc
// //     if (!transactionData.itemDesc.trim()) {
// //       errors.push("Item description is required.");
// //     }

// //     // Validate accountHead
// //     if (!transactionData.accountHead.trim()) {
// //       errors.push("Account head is required.");
// //     }

// //     // Validate value
// //     if (!transactionData.value.trim()) {
// //       errors.push("Value is required.");
// //     } else if (isNaN(Number(transactionData.value))) {
// //       errors.push("Value must be a number.");
// //     }

// //     // Validate modeOfPayment
// //     if (!transactionData.modeOfPayment.trim()) {
// //       errors.push("Mode of payment is required.");
// //     }

// //     // Validate bank
// //     if (!transactionData.bank.trim()) {
// //       errors.push("Bank is required.");
// //     }

// //     // Validate staff
// //     if (!transactionData.staff.trim()) {
// //       errors.push("Staff is required.");
// //     }

// //     return errors;
// //   };

// //   const handleSave = () => {
// //     const validationErrors = valiDate();
// //     setAlerts(true);
// //     setAlertsMess(
// //       <div
// //         style={{
// //           width: "100%",
// //           display: "flex",
// //           flexDirection: "column",
// //           justifyContent: "flex-start",
// //         }}
// //       >
// //         {validationErrors.map((item, i) => (
// //           <p style={{ textAlign: "left" }} key={i}>
// //             {item}
// //           </p>
// //         ))}
// //       </div>
// //     );
// //   };

// //   return (
// //     <div className="container">
// //       <PageHeading
// //         title={"AGENCY ASSETS"}
// //         right={
// //           <>
// //             <AddButton onClick={()=>{
// //               setFlag(true);
// //               handleAddProduct()
// //             }} />
// //             <SaveButton onClick={handleSave} />
// //             <BackButton />
// //           </>
// //         }
// //       />
// //       <div style={{ height: "20px" }}></div>

// //       {addProductData.length>0&&<Table
// //         mt={5}
// //         headData={[
// //           "TRANSACTION DATE",
// //           "TRANSACTION TYPE",
// //           "ITEM DESC",
// //           "ACCOUNT HEAD",
// //           "VALUE",
// //           "MODE OF PAYMENT",
// //           "BANK",
// //           "STAFF",
// //           "ACTIONS",
// //         ]}
// //         body={
// //           <>
// //             {addProductData.map((item) => (
// //               <tr key={item.id}>
// //                 <td>
// //                   <Input
// //                     placeholder={"Select Date"}
// //                     type={"date"}
// //                     value={transactionData.transactionDate}
// //                     onChange={(e) => handleInputChange('transactionDate', e.target.value)}
// //                     style={errors.transactionDate ? { borderColor: 'red' } : {}}
// //                   />
// //                   {errors.transactionDate && <div style={{ color: 'red', marginTop: 5 }}>{errors.transactionDate}</div>}
// //                 </td>
// //                 <td>
// //                   <Dropdown
// //                     value={transactionData.transactionType}
// //                     onChange={(e) => handleInputChange('transactionType', e.target.value)}
// //                     options={
// //                       <>
// //                         <option value="">SELECT</option>
// //                         <option value="Sale">Sale</option>
// //                         <option value="Purchase">Purchase</option>
// //                         <option value="Transfer">Transfer</option>
// //                       </>
// //                     }
// //                     style={errors.transactionType ? { borderColor: 'red' } : {}}
// //                   />
// //                   {errors.transactionType && <div style={{ color: 'red', marginTop: 5 }}>{errors.transactionType}</div>}
// //                 </td>
// //                 <td>
// //                   <Input
// //                     placeholder={"ITEM DESCRIPTION"}
// //                     type={"text"}
// //                     value={transactionData.itemDesc}
// //                     onChange={(e) => handleInputChange('itemDesc', e.target.value)}
// //                     style={errors.itemDesc ? { borderColor: 'red' } : {}}
// //                   />
// //                   {errors.itemDesc && <div style={{ color: 'red', marginTop: 5 }}>{errors.itemDesc}</div>}
// //                 </td>
// //                 <td>
// //                   <Dropdown
// //                     value={transactionData.accountHead}
// //                     onChange={(e) => handleInputChange('accountHead', e.target.value)}
// //                     options={
// //                       <>
// //                         <option value="">SELECT</option>
// //                         <option value="Assets">Assets</option>
// //                         <option value="Liabilities">Liabilities</option>
// //                       </>
// //                     }
// //                     style={errors.accountHead ? { borderColor: 'red' } : {}}
// //                   />
// //                   {errors.accountHead && <div style={{ color: 'red', marginTop: 5 }}>{errors.accountHead}</div>}
// //                 </td>
// //                 <td>
// //                   <Input
// //                     type="number"
// //                     placeholder="Value"
// //                     value={transactionData.value}
// //                     onChange={(e) => handleInputChange('value', e.target.value)}
// //                     style={errors.value ? { borderColor: 'red' } : {}}
// //                   />
// //                   {errors.value && <div style={{ color: 'red', marginTop: 5 }}>{errors.value}</div>}
// //                 </td>
// //                 <td>
// //                   <Dropdown
// //                     value={transactionData.modeOfPayment}
// //                     onChange={(e) => handleInputChange('modeOfPayment', e.target.value)}
// //                     options={
// //                       <>
// //                         <option value="">SELECT</option>
// //                         <option value="Cash">Cash</option>
// //                         <option value="Cheque">Cheque</option>
// //                         <option value="Transfer">Transfer</option>
// //                       </>
// //                     }
// //                     style={errors.modeOfPayment ? { borderColor: 'red' } : {}}
// //                   />
// //                   {errors.modeOfPayment && <div style={{ color: 'red', marginTop: 5 }}>{errors.modeOfPayment}</div>}
// //                 </td>
// //                 <td>
// //                   <Dropdown
// //                     value={transactionData.bank}
// //                     onChange={(e) => handleInputChange('staff', e.target.value)}
// //                     options={
// //                       <>
// //                         <option value="">BANK</option>
// //                         <option value="John Doe">SBI</option>
// //                         <option value="Jane Doe">PNB</option>
// //                       </>
// //                     }
// //                     style={errors.bank ? { borderColor: 'red' } : {}}
// //                   />
// //                   {errors.staff && <div style={{ color: 'red', marginTop: 5 }}>{errors.staff}</div>}
// //                 </td>
// //                 <td>
// //                   <Dropdown
// //                     value={transactionData.staff}
// //                     onChange={(e) => handleInputChange('staff', e.target.value)}
// //                     options={
// //                       <>
// //                         <option value="">SELECT</option>
// //                         <option value="John Doe">John Doe</option>
// //                         <option value="Jane Doe">Jane Doe</option>
// //                       </>
// //                     }
// //                     style={errors.staff ? { borderColor: 'red' } : {}}
// //                   />
// //                   {errors.staff && <div style={{ color: 'red', marginTop: 5 }}>{errors.staff}</div>}
// //                 </td>
// //                 <td>
// //                   <RiDeleteBin5Fill style={{ cursor: 'pointer' }} />
// //                 </td>
// //               </tr>
// //             ))}
// //           </>
// //         }
// //       />}
// //       <Table
// //         mt={5}
// //         headData={[
// //           "TRANSACTION DATE",
// //           "TRANSACTION TYPE",
// //           "ITEM DESC",
// //           "ACCOUNT HEAD",
// //           "VALUE",
// //           "MODE OF PAYMENT",
// //           "BANK",
// //           "STAFF",
// //           "ACTIONS",
// //         ]}
// //         body={
// //           <>
// //             <tr>
// //               <td>cust yes</td>
// //               <td>0.00</td>
// //               <td>0.00</td>
// //               <td>0.00</td>
// //               <td>0.00</td>
// //               <td>0.00</td>
// //               <td>0.00</td>
// //             </tr>
// //           </>
// //         }
// //       />
// //       {alerts && (
// //         <SmallModal
// //           isOpen={alerts}
// //           setIsOpen={setAlerts}
// //           title={"alert"}
// //           mess={alertsMess}
// //           okbtn={setAlertsMess}
// //         />
// //       )}
// //     </div>
// //   );
// // };

// // export default AssetsManagement;
